export const GET_TEAM_PENDING = 'get_team_pending';
export const GET_TEAM_SUCCESS = 'get_team_success';
export const GET_TEAM_FAILURE = 'get_team_failure';
export const GET_DESIGN_TEAM_SUCCESS = 'get_design_team_success'; 
export const GET_INTEGRATION_TEAM_SUCCESS = 'get_integration_team_success'; 
export const GET_INTERNAL_TEAM_SUCCESS = 'get_internal_team_success';
